import { createFileRoute } from '@tanstack/react-router';
import type { CpmCollaborationType } from '@/api/product-mapping/types';
import { CpmList } from '@/app/(client)/product-mapping/-components/CpmList';
import { useCpmListController } from '@/app/(client)/product-mapping/-hooks/useCpmListController';

export const Route = createFileRoute(
  '/(client)/product-mapping/(pages)/(list)/active/',
)({
  validateSearch: (search: Record<string, unknown>) => ({
    collaborationType:
      (search.collaborationType as CpmCollaborationType) ?? undefined,
    page: typeof search.page === 'number' ? search.page : undefined,
    limit: typeof search.limit === 'number' ? search.limit : undefined,
    sort: typeof search.sort === 'string' ? search.sort : undefined,
    filters: search.filters as Record<string, string[]> | undefined,
  }),
  component: ActiveProductMappingPage,
});

function ActiveProductMappingPage() {
  const controller = useCpmListController(false);
  return <CpmList controller={controller} isArchived={false} />;
}
